import { AssessorLayout } from '@layouts/AssessorLayout/AssessorLayout';
import { Heading } from '@acb_devel/design-system';
import { Button } from '@acb_devel/design-system';
import { PlusIcon } from '@acb_devel/design-system';
import { EventsLogsTable } from '@components/assessors/organisms/EventsLogsTable/EventsLogsTable';
import { ActiveEventsList } from '@components/assessors/organisms/ActiveEventsList/ActiveEventsList';
import { CreateEventModal } from '@components/assessors/organisms/CreateEventModal/CreateEventModal';
import { useModal } from '@acb_devel/design-system';
import { useUserContext } from '@contexts/UserContext';
import { Container } from '@layouts/Container/Container';
import { ROLE_ADMIN } from '@services/users';
import { Link } from 'react-router-dom';
import { AngleLeftIcon } from '@acb_devel/design-system';

import styles from './EventsPage.module.scss';

export default function EventsPage() {
  const { user } = useUserContext();
  const { isOpen, openModal, closeModal } = useModal();

  return (
    <>
      <AssessorLayout>
        <Container>
          <div className={styles.eventsPage}>
            <div className={styles.eventsPage__breadcrumb}>
              <Link to="/user/admin">
                <Button
                  variant="flat"
                  color="primary"
                  size="md"
                  upperCase={false}
                >
                  <AngleLeftIcon /> Volver al listado
                </Button>
              </Link>
            </div>
            <div className={styles.eventsPage__header}>
              <Heading as="h1" variant="display-4">
                Eventos
              </Heading>
              {user?.role === ROLE_ADMIN && (
                <Button variant="solid" onClick={openModal}>
                  <PlusIcon />
                  Crear evento
                </Button>
              )}
            </div>
            <div className={styles.eventsPage__content}>
              <div className={styles.eventsPage__table}>
                <EventsLogsTable />
              </div>
              <div className={styles.eventsPage__list}>
                <ActiveEventsList />
              </div>
            </div>
          </div>
        </Container>
      </AssessorLayout>
      <CreateEventModal isOpen={isOpen} onClose={closeModal} />
    </>
  );
}
